import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Districts} from './districts.model';
import * as DistrictsActions from './districts.actions';

export const districtsesFeatureKey = 'districtses';

export interface State extends EntityState<Districts> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Districts> = createEntityAdapter<Districts>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(DistrictsActions.addDistricts,
    (state, action) => adapter.addOne(action.districts, state)
  ),
  on(DistrictsActions.upsertDistricts,
    (state, action) => adapter.upsertOne(action.districts, state)
  ),
  on(DistrictsActions.addDistrictss,
    (state, action) => adapter.addMany(action.districtss, state)
  ),
  on(DistrictsActions.upsertDistrictss,
    (state, action) => adapter.upsertMany(action.districtss, state)
  ),
  on(DistrictsActions.updateDistricts,
    (state, action) => adapter.updateOne(action.districts, state)
  ),
  on(DistrictsActions.updateDistrictss,
    (state, action) => adapter.updateMany(action.districtss, state)
  ),
  on(DistrictsActions.deleteDistricts,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(DistrictsActions.deleteDistrictss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(DistrictsActions.loadDistrictss,
    (state, action) => adapter.setAll(action.districtss, state)
  ),
  on(DistrictsActions.clearDistrictss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
